import React from 'react';
import AuthRoute from './AuthRoute';

/**
 * @file ProtectedRoute.tsx
 * @brief Eine Route, die nur für authentifizierte Benutzer zugänglich ist.
 *
 * Diese Komponente überprüft, ob ein Benutzer angemeldet ist (basierend auf dem Vorhandensein eines Tokens im localStorage).
 * Wenn der Benutzer nicht angemeldet ist, wird er zur Login-Seite weitergeleitet.
 * Andernfalls wird die geschützte Route gerendert.
 *
 * @returns {JSX.Element} Ein React-Element, das entweder zur Login-Seite navigiert oder die geschützte Route rendert.
 */
import { Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  return <AuthRoute><Outlet /></AuthRoute>;
};

export default ProtectedRoute;
